"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVerificationNotice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_countdown_hook_1 = __importDefault(require("react-countdown-hook"));
const antd_1 = require("antd");
const api_1 = require("@src/api");
const elements_1 = require("@src/components/elements");
const UserVerificationNotice = () => {
    const [timeLeft, { start }] = (0, react_countdown_hook_1.default)(59 * 1000, 1 * 1000);
    const intl = (0, react_intl_1.useIntl)();
    const resendVerificationEmail = react_1.default.useCallback(async () => {
        try {
            start();
            await api_1.Account.resendVerificationEmail();
            antd_1.notification.warning({
                message: intl.formatMessage({ id: 'general.notice' }),
                description: intl.formatMessage({ id: 'admin.user_verification_notice.email_has_been_resent' }),
            });
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "m-b-m", children: (0, jsx_runtime_1.jsx)(elements_1.Alert, { showIcon: true, type: "warning", message: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.user_verification_notice.title" }), description: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.user_verification_notice.email_is_not_verified" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.user_verification_notice.email_is_not_verified_2", values: {
                                    strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                                } })] }), (0, jsx_runtime_1.jsx)("p", { className: "m-b-none", children: (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.user_verification_notice.check_your_spam_folder" }) }) })] }), action: (0, jsx_runtime_1.jsx)(antd_1.Space, { children: (0, jsx_runtime_1.jsxs)(antd_1.Button, { size: "small", onClick: resendVerificationEmail, disabled: Boolean(timeLeft), children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.user_verification_notice.send_again" }), timeLeft > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["\u00A0(", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedTime, { value: timeLeft, second: "numeric" }), ")"] }))] }) }) }) }));
};
exports.UserVerificationNotice = UserVerificationNotice;
